import React from 'react';

const money = (v: any) => `\u09F3${Number(v || 0).toLocaleString('en-BD', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
const dt = (v: any) => v ? new Date(v).toLocaleString('en-BD') : '-';

type Payment = {
  date?: string;
  method?: string;
  account?: string;
  reference?: string;
  user?: string;
  amount: number;
  type?: string;
};

export default function PaymentHistoryTable({ payments, loading }: { payments: Payment[]; loading?: boolean }) {
  if (loading) return <div style={{ padding: 20, textAlign: 'center', color: '#94a3b8' }}>Loading payments...</div>;
  if (!payments.length) return <div style={{ padding: 20, textAlign: 'center', color: '#94a3b8' }}>No payments recorded yet.</div>;

  return (
    <div style={{ overflowX: 'auto' }}>
      <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '.78rem' }}>
        <thead>
          <tr style={{ background: '#f8fafc' }}>
            <th style={th}>Date</th>
            <th style={th}>Method</th>
            <th style={th}>Account</th>
            <th style={th}>Reference</th>
            <th style={th}>User</th>
            <th style={{ ...th, textAlign: 'right' }}>Amount</th>
          </tr>
        </thead>
        <tbody>
          {payments.map((p, i) => (
            <tr key={i}>
              <td style={td}>{dt(p.date)}</td>
              <td style={td}><span style={{ padding: '2px 6px', borderRadius: 4, background: '#eff6ff', color: '#1d4ed8', fontSize: '.7rem', fontWeight: 600 }}>{p.method || '-'}</span></td>
              <td style={td}>{p.account || '-'}</td>
              <td style={{ ...td, fontSize: '.72rem', color: '#64748b' }}>{p.reference || '-'}</td>
              <td style={td}>{p.user || '-'}</td>
              <td style={{ ...td, textAlign: 'right', fontWeight: 700, color: p.type === 'RECEIPT' || Number(p.amount) > 0 ? '#059669' : '#dc2626' }}>
                {p.type === 'RECEIPT' || Number(p.amount) >= 0 ? '+' : ''}{money(p.amount)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

const th: React.CSSProperties = { padding: '7px 10px', borderBottom: '1px solid #e2e8f0', textAlign: 'left', fontSize: '.65rem', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '.04em', color: '#64748b', whiteSpace: 'nowrap' };
const td: React.CSSProperties = { padding: '7px 10px', borderBottom: '1px solid #f1f5f9', whiteSpace: 'nowrap' };
